import(/* webpackMode: "eager" */ "/home/runner/work/app-web/app-web/src/app/error.tsx");
